// @ts-nocheck
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import CanvasEditor from './CanvasEditor';

const CanvasFieldRenderer = forwardRef(function CanvasFieldRenderer(
  { value, onChange, attribute },
  ref
) {
  return (
    <CanvasEditor
      ref={ref}
      value={value}
      readOnly={!attribute?.is_editable}
      onChange={onChange}
    />
  );
});

CanvasFieldRenderer.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  attribute: PropTypes.shape({
    is_editable: PropTypes.bool,
  }).isRequired,
};

export default CanvasFieldRenderer;
